import React from "react";
import PropTypes from "prop-types";
import StepHeader from "../shared-step-sections/step-header";
import StepWrapper from "../shared-step-sections/step-wrapper";
var FinalResultStep = function FinalResultStep(_ref) {
  var content = _ref.content,
    currentStepIndex = _ref.currentStepIndex,
    stepsNumber = _ref.stepsNumber,
    score = _ref.score;
  var formattedScore = content.Heading2.replace("{score}", score);
  return /*#__PURE__*/React.createElement(StepWrapper, {
    backgroundImage: content.BackgroundImage,
    stepClassNames: "step--info"
  }, /*#__PURE__*/React.createElement(StepHeader, {
    header: content.StepHeaderTitle,
    currentStep: currentStepIndex,
    totalSteps: stepsNumber
  }), /*#__PURE__*/React.createElement("div", {
    className: "step__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__main"
  }, /*#__PURE__*/React.createElement("div", {
    className: "step__question-container"
  }, /*#__PURE__*/React.createElement("p", {
    className: "step__title",
    dangerouslySetInnerHTML: {
      __html: content.Heading
    }
  }), /*#__PURE__*/React.createElement("h2", {
    className: "step__question",
    dangerouslySetInnerHTML: {
      __html: formattedScore
    }
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
    dangerouslySetInnerHTML: {
      __html: content.Body
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "step__buttons"
  }, /*#__PURE__*/React.createElement("a", {
    href: content.SliderMinLabel,
    className: "like-orange-button",
    target: "_blank",
    dangerouslySetInnerHTML: {
      __html: content.NextButtonLabel
    }
  }), /*#__PURE__*/React.createElement("a", {
    href: content.SliderMaxLabel,
    className: "like-button",
    target: "_blank",
    dangerouslySetInnerHTML: {
      __html: content.Question
    }
  }))));
};
FinalResultStep.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  content: PropTypes.object.isRequired,
  currentStepIndex: PropTypes.number.isRequired,
  stepsNumber: PropTypes.number.isRequired,
  score: PropTypes.number.isRequired
};
export default FinalResultStep;